import { render, staticRenderFns } from "./BlogPostComment.vue?vue&type=template&id=117a119d&scoped=true"
import script from "./BlogPostComment.vue?vue&type=script&lang=js"
export * from "./BlogPostComment.vue?vue&type=script&lang=js"
import style0 from "./BlogPostComment.vue?vue&type=style&index=0&id=117a119d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117a119d",
  null
  
)

export default component.exports